import {useMappedState} from 'redux-react-hook'
import ApiSdk from 'services/callApi'
import {convertList, sortList, convertType} from 'utils/convertData'
import {Notification} from '@binance/uikit'
import {formatNumber, formatDate} from 'utils/format'

function useOpenOrders (symbolInfo) {
  const {cancelOrder} = ApiSdk.futures

  const handleCancelOrder = (i18n, lang, params) => {
    cancelOrder(params, {
      lang
    })
    .then(res => {
      if (res?.cancelOrder || res?.cancelOrders) {
        Notification({
          content: i18n.cancelOrderSuccess,
          type: 'success',
          duration: 3000
          // time: formatDate(new Date(), 'HH:mm:ss')
        })
      } else {
        Notification({
          content: res?.error?.message || i18n.failureCancelOrder,
          type: 'error',
          duration: 3000
          // time: formatDate(new Date(), 'HH:mm:ss')
        })
      }
    })
    .catch(() => {
      Notification({
        content: i18n.failureCancelOrder,
        type: 'error',
        duration: 3000,
        node: '#__next'
        // time: formatDate(new Date(), 'HH:mm:ss')
      })
    })
  }

  const mapState = state => state?.orders?.openOrders || []
  const openOrders = useMappedState(mapState)
  const {pricePrecision, quantityPrecision, lng} = symbolInfo
  return {
    openOrders: sortList(convertList(Object.values(openOrders)))?.map(v => {
      const type = v.type?.toUpperCase()
      const side = v.side?.toUpperCase()
      const isBuy = side === 'BUY'
      const isStop = type === 'STOP'
      const isProfit = type === 'TAKE_PROFIT'
      const stopPrice = v.stopPrice > 0 && (isStop || isProfit)
        ? `${(isStop && isBuy) || (isProfit && !isBuy) ? '>=' : '<='}${formatNumber(
          v.stopPrice,
          pricePrecision
        )}`
        : '-'
      return {
        ...v,
        disType: convertType(lng, type),
        disSide: (
          <span style={{color: isBuy ? '#00c582' : '#ff0371'}}>{convertType(lng, side)}</span>
        ),
        price: formatNumber(v.price, pricePrecision),
        executedQty: formatNumber(v.executedQty, quantityPrecision),
        origQty: formatNumber(v.origQty, quantityPrecision),
        stopPrice
      }
    }),
    cancelOrder: handleCancelOrder
  }
}

export default useOpenOrders
